module.exports = __webpack_public_path__ + "static/img/interactionLive01.0138cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interactionLive01.png
// module id = RGGT
// module chunks = 0